const doc = [({"Sitze":" sièges", "Sitz":" siège", "Fraktionen":"Fractions"})];
module.exports = doc.length <= 1 ? doc[0] : doc;